import { render, staticRenderFns } from "./consigneeInformation.vue?vue&type=template&id=994f4750&scoped=true"
import script from "./consigneeInformation.vue?vue&type=script&lang=js"
export * from "./consigneeInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994f4750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('994f4750')) {
      api.createRecord('994f4750', component.options)
    } else {
      api.reload('994f4750', component.options)
    }
    module.hot.accept("./consigneeInformation.vue?vue&type=template&id=994f4750&scoped=true", function () {
      api.rerender('994f4750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/orderDetailChild/consigneeInformation.vue"
export default component.exports